// extracted by mini-css-extract-plugin
module.exports = {"wutong":"wutong-2yJF4ixF"};